export var HeaderTypeTokens;
(function (HeaderTypeTokens) {
    HeaderTypeTokens["header"] = "header";
    HeaderTypeTokens["verification"] = "verification";
    HeaderTypeTokens["DEFAULT"] = "DEFAULT";
    HeaderTypeTokens["HEADERCTA"] = "HEADERCTA";
    HeaderTypeTokens["PARTNER"] = "PARTNER";
})(HeaderTypeTokens || (HeaderTypeTokens = {}));
